import { useContext, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { Button } from '@/components'

import { ConfirmationContext } from './Confirmation.context'
import { ButtonGroup, IconContainer, Modal, Overlay, Text, Title, TypedConfirmationInput } from './Confirmation.styles'

const $domElement = document.getElementById('confirm') || document.body

export function Component(): React.ReactPortal | null {
  const { isOpen, data, close } = useContext(ConfirmationContext)
  const [typedText, setTypedText] = useState('')

  useEffect(() => {
    if (isOpen) setTypedText('')
  }, [isOpen])

  function handleConfirm() {
    if (data?.onConfirm) {
      data.onConfirm()
      close()
    }
  }

  if (!isOpen || !data) return null

  const isConfirmDisabled = Boolean(data.requiredConfirmationText) && typedText !== data.requiredConfirmationText

  return createPortal(
    <Overlay>
      <Modal>
        <IconContainer>
          <data.icon size={36} />
        </IconContainer>
        <Title>{data.title}</Title>
        <Text>{data.text}</Text>
        {data.requiredConfirmationText && (
          <>
            <Text>
              Pra confirmar, digite <strong>{data.requiredConfirmationText}</strong> abaixo:
            </Text>
            <TypedConfirmationInput
              autoFocus
              value={typedText}
              onChange={(e) => setTypedText(e.target.value)}
              placeholder={data.requiredConfirmationText}
            />
          </>
        )}
        <ButtonGroup>
          <Button.Root $variant="danger" onClick={handleConfirm} disabled={isConfirmDisabled}>
            <Button.Text value={data.confirmText} />
          </Button.Root>
          <Button.Root onClick={close}>
            <Button.Text value={data.cancelText} />
          </Button.Root>
        </ButtonGroup>
      </Modal>
    </Overlay>,
    $domElement,
  )
}
